import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tempUserId: "",
    resultText: "",
    coachingDays: "",
    coachingTime: "",
    courseInfo: {
      accessCode: "",
      userId: "",
      pass: "",
      courseIdx: "",
      courseCategoryLimit: "",
      courseEmbeddedSurvey: "",
      coarchingYN: "",
      embeddedSurveyYN: "",
      userSurveyYN: "",
      userIdx: "",
    },
    userInfo: {
      accessCode: "",
      userId: "",
      pass: "",
      courseIdx: "",
      courseCategoryLimit: "",
      courseEmbeddedSurvey: "",
      userIdx: 0,
      userName: "",
      coarching: [],
      coarchingYN: "",
      embeddedSurveyYN: "",
      userSurveyYN: "",
    },
    isRebookEmbedded: false,
    currentCoarching: 0,

    pageFunc: "0",
    isReCoach: "0",
    isReRecom: "0",
  },
  mutations: {
    setIsReRcom(state, value) {
      state.isReRecom = value;
    },
    setIsReCoach(state, value) {
      state.isReCoach = value;
    },

    setpageFunc(state, value) {
      state.pageFunc = value;
    },

    setCurrentCoaching(state, value) {
      state.currentCoarching = value;
    },

    setRebbokEmbedded(state, value) {
      state.isRebookEmbedded = value;
    },
    setUserInfoId(state, value) {
      state.userInfo.userId = value;
    },
    setCourseUserIdx(state, value) {
      state.courseInfo.userIdx = value;
    },
    setCourseInfo(state, value) {
      state.courseInfo = value;
    },
    setUserIdx(state, value) {
      state.userInfo.userIdx = value;
    },
    setUserInfo(state, value) {
      state.userInfo = value;
    },
    setUserId(state, value) {
      state.tempUserId = value;
    },
    setEembeddedResult(state, value) {
      if (value == "자기관리/웰빙") {
        state.resultText = "본인의 신체적/정신적 건강을 관리하고 긍정적으로 변화시킵니다.";
      } else if (value == "자기계발/경력") {
        state.resultText =
          "본인의 커리어에 대해 주도권을 가지고 결정하고, 전환합니다. 중장기적인 목표를 설정하고 그에 맞춰 성장을 위한 지식과 기술, 구체적인 액션플랜 설정을 하는데 중용한 역할을 합니다.";
      } else if (value == "대인관계/갈등") {
        state.resultText =
          "경영능력과 조직에 따른 영향력을 강화합니다. 영향력 강화를 통한 소속감 증대와 네트워크 확장, 그리고 사업의 적극적 주도를 기대할 수 있습니다.";
      } else if (value == "커뮤니케이션(소통)") {
        state.resultText =
          "상대에 따라 적절하고 효과적인 방법을 활용하여 효과적으로 의사소통합니다. 조직 내에 원활한 소통은 업무 효율성을 높일 뿐 아니라 구성원의 사기를 향상시키고 직무 효능감을 높입니다.";
      } else if (value == "리더십") {
        state.resultText =
          "주변 사람들을 고무시키고 발전시키는 능력을 강화합니다. 적절한 리더십을 활용하면서 조직 및 구성원 간의 지지와 도움을 얻고 긍정적인 동기부여를 제공할 수 있습니다.";
      } else if (value == "성과/변화관리(혁신)") {
        state.resultText =
          "상황 별 적절한 성과 측정과 평가를 통해 성과를 관리하며 성과를 측정하고 평가하며, 변화 및 혁신을 실행할 수 있습니다.";
      } else {
        state.resultText = "Not Found";
      }
    },
    setCoachingDays(state, value) {
      let weekday = ["일", "월", "화", "수", "목", "금", "토"];
      state.coachingDays = weekday[value];
    },
    setCoachingTime(state, value) {
      const diffDate_1 = new Date("2021/01/10 " + value.start_time);
      const diffDate_2 = new Date("2021/01/10 " + value.end_time);
      const difference = diffDate_2.getTime() - diffDate_1.getTime();

      state.coachingTime = Math.floor(difference / (1000 * 60));
    },
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState()],
});
